import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { getLanguage } from '../../common/languages';

@Injectable({providedIn: 'root'})
export class OpcoPolicyLinksService {
    private opCo: string = this.appConfigService.getAppConfig().opCo;

    constructor(private appConfigService: AppConfigService) {}

    getTermsConditionLink(lang?: string): string {
        const language = lang || getLanguage();
        switch (this.opCo) {
            case 'BE01':
                switch (language) {
                    case 'nl':
                        return 'https://www.tvhequipment.com/nl/meta/algemene-voorwaarden/';
                    case 'fr':
                        return 'https://www.tvhequipment.com/fr/meta/conditions-generales/';
                    case 'de':
                        return 'https://www.tvhequipment.com/de/meta/agb/';
                    default:
                        return 'https://www.tvhequipment.com/en/meta/terms-conditions/';
                }
            case 'NL01':
                return language === 'nl'
                    ? 'https://www.mateco.nl/fileadmin/pdf/user_upload/algemene_verhuurvoorwaarden_2.pdf'
                    : 'https://www.mateco.nl/fileadmin/user_upload/General_Hire_Conditions.pdf';
            case 'DE01':
                switch (language) {
                    case 'fr':
                        return 'https://www.mateco.de/fileadmin/pdf/downloads/_mateco_AllgemeineVermietbedingungen_15.03.2021_FRA.pdf';
                    case 'de':
                        return 'https://www.mateco.de/fileadmin/pdf/downloads/_mateco_AllgemeineVermietbedingungen_15.03.2021.pdf';
                    default:
                        return 'https://www.mateco.de/fileadmin/pdf/downloads/_mateco_AllgemeineVermietbedingungen_15.03.2021_ENG.pdf ';
                }
            case 'HU01':
                switch (language) {
                    case 'hu':
                        return 'https://www.mateco-hungary.hu/hu/meta/aszf/';
                    default:
                        return 'https://www.mateco-hungary.hu/en/meta/terms-and-conditions/';
                }
        }
    }

    getPrivacyPolicyLink(lang?: string): any {
        const language = lang || getLanguage();
        return 'https://policy.qone.mateco.eu/privacy?opco=' + this.opCo + '&lang=' + language;

    }

    getCookiePolicyLink(): any {
        const language = getLanguage();
        return 'https://policy.qone.mateco.eu/cookie?opco=' + this.opCo + '&lang=' + language;
    }
}
